// ──────────────────────────────────────────────────────────────────────────
// IconaInfoModal.js — Icona ⓘ con modal centrato (D278 v148, D489 v181).
//
// Da usare quando il contenuto informativo è troppo lungo per stare nel
// SpiegaPopover compatto (320×130). Click su ⓘ → apre modal centrato con
// max-width 720px, scroll interno, chiusura via × / click overlay / Esc.
//
// API: <IconaInfoModal titolo="..." children={...} />
//   - titolo: stringa nell'header del modal
//   - children: contenuto del modal (JSX)
// ──────────────────────────────────────────────────────────────────────────

import { useState, useEffect } from "react";

export default function IconaInfoModal({ titolo, children }) {
  const [aperto, setAperto] = useState(false);

  // Chiusura con tasto Esc
  useEffect(() => {
    if (!aperto) return;
    const handler = (e) => { if (e.key === "Escape") setAperto(false); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [aperto]);

  // Blocca scroll del body quando modal aperto
  useEffect(() => {
    if (aperto) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
  }, [aperto]);

  return (
    <>
      <button
        type="button"
        onClick={() => setAperto(true)}
        aria-label="Apri istruzioni"
        title="Apri istruzioni"
        style={{
          width: 16, height: 16, borderRadius: "50%",
          background: aperto ? "#dbe7f5" : "#eef2f7",
          color: "#5a7596", border: "1px solid #cbd5e1",
          fontSize: 11, fontWeight: 600, lineHeight: "14px",
          cursor: "pointer", padding: 0, display: "inline-flex",
          alignItems: "center", justifyContent: "center",
          marginLeft: 6,
        }}
      >i</button>

      {aperto && (
        <div
          onClick={() => setAperto(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: 20,
            fontFamily: "'DM Sans',sans-serif",
            // Reset CSS per evitare ereditarietà dal parent (es. label KPI con uppercase/bold/center)
            textTransform: "none",
            letterSpacing: "normal",
            textAlign: "left",
            fontWeight: "normal",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 12,
              boxShadow: "0 20px 60px rgba(15, 23, 42, 0.3)",
              maxWidth: 720,
              width: "100%",
              maxHeight: "90vh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div style={{
              padding: "16px 22px",
              borderBottom: "1px solid #E2E8F0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "#F8FAFC",
            }}>
              <div style={{fontWeight: 700, fontSize: 16, color: "#1F2A4A"}}>
                {titolo}
              </div>
              <button
                type="button"
                onClick={() => setAperto(false)}
                aria-label="Chiudi"
                title="Chiudi"
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: 22,
                  color: "#64748B",
                  width: 30,
                  height: 30,
                  borderRadius: 4,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                  padding: 0,
                }}
              >×</button>
            </div>
            {/* Corpo scrollabile */}
            <div style={{
              padding: "20px 22px",
              overflowY: "auto",
              fontSize: 13,
              lineHeight: 1.7,
              color: "#1F2A4A",
            }}>
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
